import { action, extendObservable } from 'mobx';
import FormService from '../../../core/services/FormService';
import Papa from 'papaparse';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';

class ImportCsvService {
  form = new FormService();
  import = new FetchService();

  constructor() {
    extendObservable(this, {
      // scenes can be (in execution order): UPLOAD, PREVIEW, IMPORT, RESULT
      currentScene: 'UPLOAD',
      isOpen: false,
      loading: false,
    });
  }

  init = action(() => {
    this.form.reset();
  });

  setScene = action((scene) => (this.currentScene = scene));

  handleOpenDialog = action(() => {
    this.isOpen = true;
    this.loading = false;
    this.setScene('UPLOAD');
    this.form.reset();
  });

  handleCloseDialog = action(() => {
    this.isOpen = false;
    this.setScene('UPLOAD');
  });

  handleDiscardPreview = action(() => {
    this.setScene('UPLOAD');
    this.form.reset();
  });

  handleUpload = action(() => {
    this.loading = true;
    Papa.parse(this.form.getValue('csvFile'), {
      header: true,
      skipEmptyLines: true,
      delimiter: ';',
      complete: (results) => {
        this.form.setValue('previewData', results.data.slice(0, 50));
        this.loading = false;
        this.setScene('PREVIEW');
      },
      error: () => {
        this.setScene('UPLOAD');
        this.loading = false;
        this.form.reset();

        NotificationService.addNotification(
          'The file couldn\'t be processed. Please verify if the template is correct and if the file has ";" as column delimiter.',
          'error'
        );
      },
    });
  });

  handleImport = action(() => {
    this.loading = true;

    const bodyData = new FormData();
    bodyData.append('file', this.form.getValue('csvFile'));
    bodyData.append('locale', this.form.getValue('locale'));

    this.import
      .fetch({
        url: `/localization-items/import`,
        method: 'post',
        body: bodyData,
      })
      .then(() => {
        if (this.import.data) {
          this.form.setValue('importResult', this.import.data);
          this.setScene('RESULT');
          this.loading = false;
        }
        if (this.import.errors) {
          this.setScene('UPLOAD');
          this.form.reset();
          this.loading = false;
        }
      });
  });
}

const importCsvService = new ImportCsvService();
export default importCsvService;
